import { createContext, Dispatch, useContext, useReducer } from "react";
import { MsUser } from "../types/interface";
import { InitMsUser } from "../types/initObject";

const UserStateContext = createContext<MsUser | undefined>(undefined);

type Action =
  | { type: "LOGIN"; item: MsUser }
  | { type: "CHANGE_AUTH"; item: MsUser }
  | { type: "LOGOUT" };

type UserDispatch = Dispatch<Action>;
const UserDispatchContext = createContext<UserDispatch | undefined>(undefined);

function UserReducer(state: MsUser, action: Action): MsUser {
  switch (action.type) {
    case "LOGIN":
      return {
        ...action.item,
      };
    case "CHANGE_AUTH":
      return {
        ...action.item,
      };
    case "LOGOUT": {
      return InitMsUser;
    }
  }
}

export function UserContextProvider({ children }: { children: React.ReactNode }) {
  const [state, dispatch] = useReducer(UserReducer, InitMsUser);
  return (
    <UserDispatchContext.Provider value={dispatch}>
      <UserStateContext.Provider value={state}>{children}</UserStateContext.Provider>
    </UserDispatchContext.Provider>
  );
}

//custom hook
export function useUserState() {
  const state = useContext(UserStateContext);
  if (!state) throw new Error("UserStateProvider not found");
  return state;
}

export function useUserDispatch() {
  const dispatch = useContext(UserDispatchContext);
  if (!dispatch) throw new Error("UserDispatchProvider not found");
  return dispatch;
}
